import { Box, CircularProgress, Stack } from "@mui/material";

const LoadingPage = () => {
    return (
        <Box sx={{ width: "100%", height: "80vh", background: "white" }}>
            <Stack alignItems={"center"} justifyContent={"center"} sx={{ height: "100%", background: "rgba(255,255,255,0.5)" }}>
                <CircularProgress thickness={2} color="warning" />
            </Stack>
        </Box>
    )
}

export default LoadingPage;